<template>
  <div class="datepicker">
    <!--MONTH-->
    <div class="input-wrapper" :class="{'error-input' : error && !blurred}">
      <input
          type="text"
          name="month"
          class="input"
          placeholder="Month"
          v-model="selectedMonth.abbreviation"
          @click="onClickMonth()"
          @keydown.down="onArrowDownMonth()"
          @keydown.up="onArrowUpMonth()"
          @keydown.enter="onEnterMonth()"
          @keyup.tab="onTabClickMonth()"
          autocomplete="off"
          readonly />
      <div class="icon-wrapper" @click="onClickMonth()">
        <img src='@/assets/images/arrow_down.png' />
      </div>
      <ul v-show="isOpenMonth" class="results month" ref="monthContainer">
        <li
            v-for="(month, indexMonth) in months"
            :key="indexMonth"
            @click="setResultMonth(month)"
            :class="{ 'is-active': indexMonth === arrowCounterMonth, 'disabled': isMonthDisabled(month) }"
            :disabled="isMonthDisabled(month)"
            ref="monthOption">
          <span>{{ month.abbreviation }}</span>
        </li>
      </ul>
    </div>
    
    <!--DAY-->
    <div class="input-wrapper" :class="{'error-input' : error && !blurred}">
      <input
        type="text"
        name="day"
        class="input"
        placeholder="Day"
        v-model="selectedDay"
        @click="onClickDay()"
        @keydown.down="onArrowDownDay()"
        @keydown.up="onArrowUpDay()"
        @keydown.enter="onEnterDay()"
        @keyup.tab="onTabClickDay()"
        autocomplete="off"
        readonly />
      <div class="icon-wrapper" @click="onClickDay()">
        <img src='@/assets/images/arrow_down.png' />
      </div>
      <ul v-show="isOpenDay" class="results" ref="dayContainer">
        <li
          v-for="(day, indexDay) in days"
          :key="indexDay"
          @click="setResultDay(day)"
          :class="{ 'is-active': indexDay === arrowCounterDay, 'disabled': isDateDisabled(day) }"
          :disabled="isDateDisabled(day)"
          ref="dayOption">
          <span>{{ day }}</span>
        </li>
      </ul>
    </div>
    
    <!--YEAR-->
    <div class="input-wrapper" :class="{'error-input' : error && !blurred}">
      <input
        type="text"
        name="year"
        class="input"
        placeholder="Year"
        v-model="selectedYear"
        @click="onClickYear()"
        @keydown.down="onArrowDownYear()"
        @keydown.up="onArrowUpYear()"
        @keydown.enter="onEnterYear()"
        @keyup.tab="onTabClickYear()"
        @keydown.tab="onTabOffYear()"
        autocomplete="off"
        readonly />
      <span class="icon-wrapper" @click="onClickYear">
        <img src='@/assets/images/arrow_down.png' />
      </span>
      <ul v-show="isOpenYear" class="results" ref="yearContainer">
        <li
          v-for="(year, indexYear) in years"
          :key="indexYear"
          @click="setResultYear(year)"
          :class="{ 'is-active': indexYear === arrowCounterYear, 'disabled': isYearDisabled(year) }"
          :disabled="isYearDisabled(year)"
          ref="yearOption">
          <span>{{ year }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { dateFilter } from 'vue-date-fns';
  import { getDaysInMonth } from 'date-fns';
  
  export default {
    name: "FPDatepicker",
    props: {
      option: {
        type: String,
        required: false,
        default: () => ''
      },
      initialBlank: {
        type: Boolean,
        required: false,
        default: () => false
      },
      dateOfBirth: {
        type: Boolean,
        required: false,
        default: () => false
      },
      forbidFuture: {
        type: Boolean,
        required: false,
        default: () => false
      },
      forbidPast: {
        type: Boolean,
        required: false,
        default: () => false
      },
      forbidSixteen: {
        type: Boolean,
        required: false,
        default: () => false
      },
      forbidFromComparedDate: {
        type: Boolean,
        required: false,
        default: () => false
      },
      comparedDate: {
        type: Date,
        required: false,
        default: () => new Date()
      }
    },
    filters: {
      date: dateFilter
    },
    data() {
      return {
        date: new Date(),
        // Days
        selectedDay: 1,
        isOpenDay: false,
        arrowCounterDay: -1,
        // Months
        selectedMonth: {},
        isOpenMonth: false,
        arrowCounterMonth: -1,
        months: [
          {
            abbreviation: "Jan",
            name: "January",
            number: 0,
          },
          {
            abbreviation: "Feb",
            name: "February",
            number: 1,
          },
          {
            abbreviation: "Mar",
            name: "March",
            number: 2,
          },
          {
            abbreviation: "Apr",
            name: "April",
            number: 3,
          },
          {
            abbreviation: "May",
            name: "May",
            number: 4,
          },
          {
            abbreviation: "Jun",
            name: "June",
            number: 5,
          },
          {
            abbreviation: "Jul",
            name: "July",
            number: 6,
          },
          {
            abbreviation: "Aug",
            name: "August",
            number: 7,
          },
          {
            abbreviation: "Sep",
            name: "September",
            number: 8,
          },
          {
            abbreviation: "Oct",
            name: "October",
            number: 9,
          },
          {
            abbreviation: "Nov",
            name: "November",
            number: 10,
          },
          {
            abbreviation: "Dec",
            name: "December",
            number: 11,
          }
        ],
        // Year
        selectedYear: 2019,
        isOpenYear: false,
        arrowCounterYear: -1,
        // Common
        error: false,
        blurred: false,
        lastFocus: ''
      };
    },
    computed: {
      days: function() {
        let daysTemp = [];
        if (this.selectedMonth) {
          for (let i = 1; i <= getDaysInMonth(new Date(this.selectedYear, this.months.indexOf(this.selectedMonth), 1)); i++) {
            daysTemp.push(i)
          }
        } else {
          for (let i = 1; i <= 31; i++) {
            daysTemp.push(i)
          }
        }
        return daysTemp
      },
      years: function () {
        let yearsTemp = [];
        if (this.dateOfBirth) {
          for (let i = new Date().getFullYear(); i >= 1900; i--) {
            yearsTemp.push(i)
          }
        } else {
          for (let i = new Date().getFullYear() + 10; i >= 1970; i--) {
            yearsTemp.push(i)
          }
        }
        return yearsTemp
      },
    },
    watch: {
      option: function (val) {
        this.setInitialDate(val)
      }
    },
    mounted() {
      this.setInitialDate(this.option);
      
      document.addEventListener("click", this.handleClickOutside);
    },
    destroyed() {
      document.addEventListener("click", this.handleClickOutside);
    },
    methods: {
      setInitialDate(date) {
        if (!this.initialBlank) {
          if (date === '') {
            this.selectedDay = this.date.getDate();
            let monthNumber = this.date.getMonth();
            this.selectedMonth = this.months.find(month => month.number === monthNumber);
            this.selectedYear = this.date.getFullYear();
          } else {
            let dateTemp = new Date(date);
            this.selectedDay = dateTemp.getDate();
            let monthNumber = dateTemp.getMonth();
            this.selectedMonth = this.months.find(month => month.number === monthNumber);
            this.selectedYear = dateTemp.getFullYear();
          }
        } else {
          this.selectedDay = '';
          this.selectedMonth = {};
          this.selectedYear = ''
        }
        
        this.arrowCounterDay = this.days.indexOf(this.selectedDay);
        this.arrowCounterMonth = this.months.indexOf(this.selectedMonth);
        this.arrowCounterYear = this.years.indexOf(parseInt(this.selectedYear));
      },
      // Day methods
      onClickDay() {
        this.isOpenDay = !this.isOpenDay;
        this.lastFocus = 'day';
        this.blurred = true;
        this.fixScrollDay();
        this.$emit("click", this.blurred);
      },
      onTabClickDay() {
        if (!this.isOpenDay) {
          this.onClickDay();
          this.isOpenMonth = false;
          this.isOpenYear = false;
        } else {
          this.isOpenDay = false;
          this.arrowCounterDay = -1;
        }
      },
      setResultDay(day) {
        this.selectedDay = day;
        this.isOpenDay = false;
        this.blurred = false;
        this.$emit("click", this.blurred);
        this.onChange();
      },
      onArrowDownDay() {
        if (this.arrowCounterDay < this.days.length) {
          this.arrowCounterDay = this.arrowCounterDay + 1;
          this.fixScrollDay();
        }
      },
      onArrowUpDay() {
        if (this.arrowCounterDay > 0) {
          this.arrowCounterDay = this.arrowCounterDay - 1;
          this.fixScrollDay();
        }
      },
      onEnterDay() {
        if (this.days[this.arrowCounterDay]) {
          this.selectedDay = this.days[this.arrowCounterDay];
          this.onChange();
          this.isOpenDay = false;
          this.arrowCounterDay = -1;
        }
      },
      // Month methods
      onClickMonth() {
        this.isOpenMonth = !this.isOpenMonth;
        this.lastFocus = 'month';
        this.blurred = true;
        this.fixScrollMonth();
        this.$emit("click", this.blurred);
      },
      onTabClickMonth() {
        if (!this.isOpenMonth) {
          this.onClickMonth();
          this.isOpenDay = false;
          this.isOpenYear = false;
        } else {
          this.isOpenMonth = false;
          this.arrowCounterMonth = -1;
        }
      },
      setResultMonth(month) {
        const date = new Date();
        this.selectedMonth = month;
        if (this.forbidPast) {
          if (this.selectedDay < date.getDate() && (this.selectedMonth.number <= date.getMonth() && this.selectedYear <= date.getFullYear())) {
            this.selectedDay = date.getDate();
          }
        }
        else if (this.forbidFuture) {
          if (this.selectedDay > date.getDate() && this.selectedMonth.number >= date.getMonth() && this.selectedYear >= date.getFullYear()) {
            this.selectedDay = date.getDate();
          }
        }
        else if (this.forbidSixteen) {
          if (this.selectedDay > date.getDate() && this.selectedMonth.number >= date.getMonth() && this.selectedYear >= date.getFullYear() - 16) {
              this.selectedDay = date.getDate();
          }
        }
        else if (this.forbidFromComparedDate) {
          if (this.selectedDay < this.comparedDate.getDate() && (this.selectedMonth.number <= this.comparedDate.getMonth() && this.selectedYear <= this.comparedDate.getFullYear())) {
            this.selectedDay = this.comparedDate.getDate();
          }
        }
        this.blurred = false;
        this.$emit("click", this.blurred);
        if (this.selectedDay > this.days.length) {
          this.selectedDay = 1
        }
        
        this.isOpenMonth = false;
        this.onChange();
      },
      onArrowDownMonth() {
        if (this.arrowCounterMonth < this.months.length) {
          this.arrowCounterMonth = this.arrowCounterMonth + 1;
          this.fixScrollMonth();
        }
      },
      onArrowUpMonth() {
        if (this.arrowCounterMonth > 0) {
          this.arrowCounterMonth = this.arrowCounterMonth - 1;
          this.fixScrollMonth();
        }
      },
      onEnterMonth() {
        if (this.months[this.arrowCounterMonth]) {
          this.selectedMonth = this.months[this.arrowCounterMonth];
          this.onChange();
          this.isOpenMonth = false;
          this.arrowCounterMonth = -1;
        }
      },
      // Year methods
      onClickYear() {
        this.isOpenYear = !this.isOpenYear;
        this.lastFocus = 'year';
        this.blurred = true;
        this.fixScrollYear();
        this.$emit("click", this.blurred);
      },
      onTabClickYear() {
        if (!this.isOpenYear) {
          this.onClickYear();
          this.isOpenDay = false;
          this.isOpenMonth = false;
        } else {
          this.isOpenYear = false;
          this.arrowCounterYear = -1;
        }
      },
      onTabOffYear () {
        this.isOpenYear = false;
        this.arrowCounterYear = -1;
      },
      setResultYear(year) {
        const date = new Date();
        this.selectedYear = year;
        if (this.forbidPast) {
          if (this.selectedDay < date.getDate() && (this.selectedMonth.number <= date.getMonth() && this.selectedYear <= date.getFullYear())) {
            this.selectedDay = date.getDate();
          }
          if (this.selectedMonth.number < date.getMonth() && this.selectedYear <= date.getFullYear()) {
            this.selectedMonth = this.months[date.getMonth()];
          }
        }
        else if (this.forbidFuture) {
          if (this.selectedDay > date.getDate() && this.selectedMonth.number >= date.getMonth() && this.selectedYear >= date.getFullYear()) {
            this.selectedDay = date.getDate();
          }
          if (this.selectedMonth.number > date.getMonth() && this.selectedYear >= date.getFullYear()) {
            this.selectedMonth = this.months[date.getMonth()];
          }
        }
        else if (this.forbidSixteen) {
          if (this.selectedDay > date.getDate() && this.selectedMonth.number >= date.getMonth() && this.selectedYear >= date.getFullYear() - 16) {
            this.selectedDay = date.getDate();
          }
          if (this.selectedMonth.number > date.getMonth() && this.selectedYear >= date.getFullYear() - 16) {
            this.selectedMonth = this.months[date.getMonth()];
          }
        }
        else if (this.forbidFromComparedDate) {
          if (this.selectedDay < this.comparedDate.getDate() && (this.selectedMonth.number <= this.comparedDate.getMonth() && this.selectedYear <= this.comparedDate.getFullYear())) {
            this.selectedDay = this.comparedDate.getDate();
          }
          if (this.selectedMonth.number < this.comparedDate.getMonth() && this.selectedYear <= this.comparedDate.getFullYear()) {
            this.selectedMonth = this.months[this.comparedDate.getMonth()];
          }
        }
        this.isOpenYear = false;
        this.blurred = false;
        this.$emit("click", this.blurred);
        this.onChange();
      },
      onArrowDownYear() {
        if (this.arrowCounterYear < this.years.length) {
          this.arrowCounterYear = this.arrowCounterYear + 1;
          this.fixScrollYear();
        }
      },
      onArrowUpYear() {
        if (this.arrowCounterYear > 0) {
          this.arrowCounterYear = this.arrowCounterYear - 1;
          this.fixScrollYear();
        }
      },
      onEnterYear() {
        if(this.years[this.arrowCounterYear]) {
          this.selectedYear = this.years[this.arrowCounterYear];
          this.onChange();
          this.isOpenYear = false;
          this.arrowCounterYear = -1;
        }
      },
      // Common methods
      handleClickOutside(evt) {
        if (!this.$el.contains(evt.target)) {
          this.isOpenDay = false;
          this.arrowCounterDay = -1;
          this.isOpenMonth = false;
          this.arrowCounterMonth = -1;
          this.isOpenYear = false;
          this.arrowCounterYear = -1;
          this.blurred = false;
        } else {
          if (this.lastFocus === 'day') {
            this.isOpenMonth = false;
            this.isOpenYear = false;
          } else if (this.lastFocus === 'month') {
            this.isOpenDay = false;
            this.isOpenYear = false;
          } else if (this.lastFocus === 'year') {
            this.isOpenDay = false;
            this.isOpenMonth = false;
          }
        }
      },
      onChange() {
        if(this.selectedDay === '' && !this.selectedMonth.number && this.selectedYear === '') {
          this.optionChanged('')
        } else {
          if(!this.initialBlank || (this.selectedDay !== '' && this.selectedMonth.number && this.selectedYear !== '')) {
              this.date.setDate(this.selectedDay);
              this.date.setMonth(this.selectedMonth.number);
              this.date.setFullYear(this.selectedYear);
              this.optionChanged(this.date);
          }
        }
      },
      optionChanged(date) {
        this.$emit("optionChanged", date);
      },
      fixScrollDay() {
        let self = this;
        setTimeout(function() {
          if(self.$refs.dayOption[self.arrowCounterDay]) {
          const liH = self.$refs.dayOption[self.arrowCounterDay].clientHeight;
          self.$refs.dayContainer.scrollTop = liH * parseInt(self.arrowCounterDay);
          }
        }, 10);
      },
      fixScrollMonth() {
        let self = this;
        setTimeout(function() {
          if(self.$refs.monthOption[self.arrowCounterMonth]) {
            const liH = self.$refs.monthOption[self.arrowCounterMonth].clientHeight;
            self.$refs.monthContainer.scrollTop = liH * self.arrowCounterMonth;
          }
        }, 10);
      },
      fixScrollYear() {
        let self = this;
        setTimeout(function() {
          if(self.$refs.yearOption[self.arrowCounterYear]) {
            const liH = self.$refs.yearOption[self.arrowCounterYear].clientHeight;
            self.$refs.yearContainer.scrollTop = liH * self.arrowCounterYear;
          }
        }, 10);
      },
      setError(value) {
        this.error = value;
      },
      clearSelections() {
        this.selectedDay = '';
        this.selectedMonth = {};
        this.selectedYear = ''
      },

      isDateDisabled(day) {
        if (this.forbidFuture) {
          if (this.selectedMonth.number === new Date().getMonth() && this.selectedYear === new Date().getFullYear()) {
            return day > new Date().getDate();
          }
          return false;
        }
        else if (this.forbidPast) {
            if (this.selectedMonth.number === new Date().getMonth() && this.selectedYear === new Date().getFullYear()) {
              return day < new Date().getDate();
            }
            return false;
        }
        else if (this.forbidSixteen) {
          if (this.selectedMonth.number === new Date().getMonth() && this.selectedYear === new Date().getFullYear() - 16) {
            return day > new Date().getDate();
          }
          return false;
        }
        else if (this.forbidFromComparedDate) {
          if (this.selectedMonth.number === this.comparedDate.getMonth() && this.selectedYear === this.comparedDate.getFullYear()) {
            return day < this.comparedDate.getDate();
          }
          return false;
        }
        return false;
      },

      isMonthDisabled(month) {
        if (this.forbidFuture) {
          if (this.selectedYear === new Date().getFullYear()) {
            return month.number > new Date().getMonth();
          }
          return false;
        }
        else if (this.forbidPast) {
          if (this.selectedYear === new Date().getFullYear()) {
            return month.number < new Date().getMonth();
          }
          return false;
        }
        else if (this.forbidSixteen) {
          if (this.selectedYear === new Date().getFullYear() - 16) {
            return month.number > new Date().getMonth();
          }
          return false;
        }
        else if (this.forbidFromComparedDate) {
          if (this.selectedYear === this.comparedDate.getFullYear()) {
            return month.number < this.comparedDate.getMonth();
          }
          return false;
        }
        return false;
      },

      isYearDisabled(year) {
        if (this.forbidFuture) {
          return year > new Date().getFullYear();
        }
        else if (this.forbidPast) {
          return year < new Date().getFullYear();
        }
        else if (this.forbidSixteen) {
          return year > new Date().getFullYear() - 16;
        }
        if (this.forbidFromComparedDate) {
          return year < this.comparedDate.getFullYear();
        }
        return false;
      }
    }
  };
</script>
